import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", to = "/" }) => {
  return (
    <Link
      to={to}
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2.5 group ${className}`}
    >
      <span
        aria-hidden
        className="relative inline-flex h-10 w-10 items-center justify-center rounded-xl overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, rgba(2,132,199,0.12), rgba(56,189,248,0.08))",
          border: "1px solid var(--osx-border-strong)",
          boxShadow: "0 8px 22px rgba(2,132,199,0.22)",
        }}
      >
        <img
          src="/assets/logo.png"
          alt="OptiShield X logo"
          className="h-8 w-8 object-contain transition-transform duration-300 group-hover:scale-110"
          draggable={false}
        />
      </span>
      <span className="flex items-baseline gap-1.5">
        <span
          className="text-lg sm:text-xl font-bold tracking-tight"
          style={{ fontFamily: "var(--font-heading)", color: "var(--osx-text)" }}
        >
          OptiShield
        </span>
        <span
          className="text-lg sm:text-xl font-bold"
          style={{ fontFamily: "var(--font-heading)", color: "var(--osx-brand-600)" }}
        >
          X
        </span>
      </span>
    </Link>
  );
};
